async function geoLocation(info) {
  const apiKey = 'p-0rfisLIEXLvkS2xd8oN_y3Tdb3faOWsJ98hU90d2U'

  const url = `https://geocode.search.hereapi.com/v1/geocode?qq=postalCode=${encodeURIComponent(info.cp)};houseNumber=${encodeURIComponent(info.house_number)}&apiKey=${apiKey}`

  const response = await fetch(url)

  // eslint-disable-next-line
  if (!response.ok) {
    // eslint-disable-next-line
    throw new Error('Error al consultar HERE API: ' + response.status)
  }

  const data = await response.json()

  // Si no devuelve datos
  if (!data.items || data.items.length === 0) {
    return null
  }

  const item = data.items[0]
  const address = item.address || {}

  return {
    street: address.street || null,
    city: address.city || null,
    latitude: item.position?.lat || null,
    longitude: item.position?.lng || null,
  }
}

export default {
  geoLocation,
}
